import {_sharedActionsConstantsShop} from "./actions";
import {_sharedActionsConstantsSystem} from "../system/actions";

export const _sharedStateShop = {
  pendingIds: new Set(),
  loadingPackages: false,
  isPackagesFetched: false,
  shopIds: [],
  shopBooks: {},
  packageIds: [],
  shopPackages: {},
  allShopBooks: [],
};

export const _sharedReducerShop = (state, action, initialState) => {
  switch (action.type) {
    case _sharedActionsConstantsShop.FETCH_ALL_SHOP_BOOKS_SUCCESS: {
      return { ...state, allShopBooks: action.data };
    }
    case _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_SUCCESS: {
      const updatedPendingIds = new Set(state.pendingIds);
      const updatedShopIds = [...state.shopIds];
      const updatedShopBooks = { ...state.shopBooks };
      action.data.bookIds.forEach((bookId) => {
        updatedPendingIds.delete(bookId);
      });
      action.data.books?.forEach((shopBook) => {
        updatedShopIds.push(shopBook.book_id);
        updatedShopBooks[shopBook.book_id] = shopBook;
      });
      return {
        ...state,
        pendingIds: updatedPendingIds,
        shopIds: [...new Set(updatedShopIds)],
        shopBooks: updatedShopBooks,
      };
    }
    case _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_PENDING: {
      const updatedPendingIds = new Set(state.pendingIds);
      action.data.forEach((bookId) => updatedPendingIds.add(bookId));
      return { ...state, pendingIds: updatedPendingIds };
    }
    case _sharedActionsConstantsShop.FETCH_PACKAGES_PENDING: {
      return { ...state, loadingPackages: true };
    }
    case _sharedActionsConstantsShop.FETCH_PACKAGES_SUCCESS: {
      const updatedPackageIds = [...state.packageIds];
      const updatedShopPackages = { ...state.shopPackages };
      action.data.forEach((shopPackage) => {
        updatedPackageIds.push(shopPackage.id);
        updatedShopPackages[shopPackage.id] = shopPackage;
      });
      return {
        ...state,
        shopPackages: updatedShopPackages,
        packageIds: updatedPackageIds,
        loadingPackages: false,
        isPackagesFetched: true,
      };
    }
    case _sharedActionsConstantsShop.SET_IS_PACKAGE_FETCHED: {
      return {
        ...state,
        isPackagesFetched: action.data,
      };
    }
    case _sharedActionsConstantsShop.RESTORE_SHOP: {
      const { shopPackages, shopBooks } = action.data;
      const updatedPackageIds = [...state.packageIds];
      const updatedShopIds = [...state.shopIds];
      const updatedShopBooks = { ...state.shopBooks };
      const updatedShopPackages = { ...state.shopPackages };
      shopPackages.forEach((shopPackage) => {
        updatedPackageIds.push(shopPackage.id);
        updatedShopPackages[shopPackage.id] = shopPackage;
      });
      shopBooks.forEach((shopBook) => {
        updatedShopIds.push(shopBook.book_id);
        updatedShopBooks[shopBook.book_id] = shopBook;
      });
      return {
        ...state,
        shopIds: [...new Set(updatedShopIds)],
        shopBooks: updatedShopBooks,
        shopPackages: updatedShopPackages,
        packageIds: [...new Set(updatedPackageIds)],
      };
    }
    case _sharedActionsConstantsSystem.SET_IS_LOGIN:
    case _sharedActionsConstantsShop.RESET_SHOP: {
      if (
        action.type === _sharedActionsConstantsSystem.SET_IS_LOGIN
        && action.data === true
      ) {
        return state;
      }

      return initialState;
    }
    default:
      return state;
  }
};
